import { render, staticRenderFns } from "./listMain.vue?vue&type=template&id=5054ae7d&scoped=true"
import script from "./listMain.vue?vue&type=script&lang=js"
export * from "./listMain.vue?vue&type=script&lang=js"
import style0 from "./listMain.vue?vue&type=style&index=0&id=5054ae7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5054ae7d",
  null
  
)

export default component.exports